import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { FaInstagram, FaFacebook, FaLinkedin, FaEnvelope } from "react-icons/fa";
import site from "../../content/site.json";

const icons = { Instagram: FaInstagram, Facebook: FaFacebook, LinkedIn: FaLinkedin, Email: FaEnvelope };

export default function Socials() {
  const theme = useTheme();
  const links = [...site.socials, { name: "Email", url: `mailto:${site.email}` }];
  return (
    <Box component="footer" sx={{ bgcolor: theme.palette.primary.dark, color: "white", textAlign: "center", py: 4, px: 2 }}>
      <Typography component="p" variant="h6" sx={{ fontWeight: 900, mb: 1 }}>CYRENAEUS</Typography>
      <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mb: 1.5 }}>
        {links.map(({ name, url }) => {
          const Icon = icons[name];
          const external = url.startsWith("https:");
          return (
            <IconButton key={name} component="a" href={url}
              aria-label={name === "Email" ? "Email Cyrenaeus" : `Cyrenaeus on ${name} (opens in a new tab)`}
              target={external ? "_blank" : undefined} rel={external ? "noopener noreferrer" : undefined}
              sx={{ color: "white", bgcolor: "rgba(255,255,255,0.1)", "&:hover": { bgcolor: "rgba(255,255,255,0.18)" } }}>
              <Icon aria-hidden="true" size={24} />
            </IconButton>
          );
        })}
      </Box>
      <Typography variant="caption" sx={{ color: "lightGrey", textDecoration: "none" }} component="a"
        href="https://register-of-charities.charitycommission.gov.uk/en/charity-search/-/charity-details/5211178/charity-overview"
        target="_blank" rel="noopener noreferrer">
        UK registered charity. Charity number: 1202741
      </Typography>
    </Box>
  );
}
